import type { Thunk } from 'state/state.common';
import type { TabsForWorkspace } from 'state/workspaces/model';

import { secondaryMarketBcsProductFetchRequested } from './bcsProduct.actions';
import { hasSecondaryMarketRealtimeBcsProductLoaded } from './bcsProduct.selectors';
export function secondaryMarketBcsProductRequestRetryThunk(
  tabId: string,
  tabType: TabsForWorkspace['secondaryMarketQuotes'],
): Thunk<void> {
  return (
    dispatch,
    getState,
    {
      selectors: {
        fromSecondaryQuotesWorkspace: { getProductKey: getProductKeyFromSecondaryMarketQuotesWorkspaceTab },
      },
    },
  ) => {
    const state = getState();
    const rowId = getProductKeyFromSecondaryMarketQuotesWorkspaceTab(state, tabId);

    dispatch(secondaryMarketBcsProductFetchRequested(tabId, tabType, rowId));
  };
}

export function secondaryMarketBcsProductFetchRequestedUnlessLoadedThunk(
  tabId: string,
  tabType: TabsForWorkspace['secondaryMarketQuotes'],
): Thunk<void> {
  return (
    dispatch,
    getState,
    {
      selectors: {
        fromSecondaryQuotesWorkspace: { getProductKey: getProductKeyFromSecondaryMarketQuotesWorkspaceTab },
      },
    },
  ) => {
    const state = getState();
    const rowId = getProductKeyFromSecondaryMarketQuotesWorkspaceTab(state, tabId);
    if (!hasSecondaryMarketRealtimeBcsProductLoaded(state, rowId)) {
      dispatch(secondaryMarketBcsProductFetchRequested(tabId, tabType, rowId));
    }
  };
}
